var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.576 2.504V8.04C12.576 9.16 12.2933 10.12 11.728 10.92C11.1733 11.72 10.48 12.3227 9.648 12.728C8.82667 13.1227 8.02667 13.32 7.248 13.32C6.224 13.32 5.30133 13.112 4.48 12.696C3.66933 12.2693 3.03467 11.688 2.576 10.952C2.128 10.2053 1.904 9.368 1.904 8.44V1.928L0.144 1.464L0.656 0.424H6.32V1.32L4.8 2.504V7.864C4.8 9.00533 5.09333 9.896 5.68 10.536C6.26667 11.1653 7.152 11.48 8.336 11.48C8.784 11.48 9.22667 11.3467 9.664 11.08C10.1013 10.8027 10.464 10.4027 10.752 9.88C11.04 9.35733 11.184 8.73867 11.184 8.024V2.184L9.328 1.464L9.84 0.424H14.096V1.32L12.576 2.504Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.8a28ddab7bbd8ac1f321605fd4052a1a.svg";
export { ForwardRef as ReactComponent };